import React from "react";

type ModalProps = {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  children: React.ReactNode;
  size?: "small" | "medium" | "large";
  panelClassName?: string;
  headerClassName?: string;
  titleClassName?: string;
  bodyClassName?: string;
  closeIconSrc?: string;
};

const sizeClassMap: Record<NonNullable<ModalProps["size"]>, string> = {
  small: "max-w-[620px]",
  medium: "max-w-[940px]",
  large: "max-w-[1140px]",
};

export default function Modal({
  isOpen,
  onClose,
  title,
  children,
  size = "medium",
  panelClassName = "",
  headerClassName = "",
  titleClassName = "",
  bodyClassName = "",
  closeIconSrc,
}: ModalProps) {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay fixed inset-0 z-[10000] flex items-center justify-center bg-black/[0.31] p-4">
      <div className={`modal-container max-h-[calc(100dvh-2rem)] w-full overflow-y-auto rounded-[16px] bg-white shadow-sm ${sizeClassMap[size]} ${panelClassName}`}>
        <div className={`relative border-b border-border-grey px-4 py-4 sm:px-6 ${headerClassName}`}>
          <h2 className={`mt-8 m-0 leading-none text-md font-semibold text-dark-black text-left ${titleClassName}`}>{title || ""}</h2>
          <button
            type="button"
            onClick={onClose}
            aria-label="Close"
            className="absolute right-0 top-0 flex h-10 w-10 items-center justify-center rounded-full hover:bg-primary"
          >
            {closeIconSrc ? (
              <img src={closeIconSrc} alt="" aria-hidden="true" className="h-6 w-6" />
            ) : (
              <span className="text-2xl leading-none text-dark-grey">&times;</span>
            )}
          </button>
        </div>
        <div className={`px-4 py-5 sm:px-6 ${bodyClassName}`}>{children}</div>
      </div>
    </div>
  );
}
